'use client';

import { c as _c } from "react/compiler-runtime";
import { Input } from '@pc/components/ui/input';
import './LawCustomInput.scss';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useModalStore from '@module/stores/useModalStore';
import type { JSX } from 'react';
interface Props {
  placeholder?: string;
  title: string;
  children?: JSX.Element[] | JSX.Element;
  value?: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
  maxLength?: number;
}
function LawCustomInput(props) {
  const $ = _c(16);
  const {
    children,
    title,
    placeholder,
    value,
    onChange,
    readOnly,
    maxLength
  } = props;
  const {
    isLogin
  } = useGetLoginInfoQuery();
  const {
    pushModal
  } = useModalStore();
  let t0;
  if ($[0] !== title) {
    t0 = <div className="title">{title}</div>;
    $[0] = title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== children || $[3] !== isLogin || $[4] !== maxLength || $[5] !== onChange || $[6] !== placeholder || $[7] !== pushModal || $[8] !== readOnly || $[9] !== value) {
    t1 = children || <Input maxLength={maxLength} onClick={() => {
      if (!isLogin) {
        pushModal({
          type: "AUTH_MODAL",
          id: "LawCustomInput"
        });
      }
    }} readOnly={readOnly} placeholder={placeholder} value={value} onChange={e => {
      onChange?.(e.target.value);
    }} />;
    $[2] = children;
    $[3] = isLogin;
    $[4] = maxLength;
    $[5] = onChange;
    $[6] = placeholder;
    $[7] = pushModal;
    $[8] = readOnly;
    $[9] = value;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== t1) {
    t2 = <div className="con">{t1}</div>;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t0 || $[14] !== t2) {
    t3 = <div className="law-custom-input">{t0}{t2}</div>;
    $[13] = t0;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}
export default LawCustomInput;